import * as yup from "yup";
import { FormInputMeta, FormSelectInputOptionMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IBatchesMonitoringFilterFormMeta {
  module: FormInputMeta;
  unknown: FormInputMeta;
  date: FormInputMeta;

  schema: any;
}

const BatchesMonitoringFilterFormMeta = {} as IBatchesMonitoringFilterFormMeta;

export const moduleEnum: {[x: string]: string} = {
    
    archiving: 'Archivage',
        
        merchantManagement: 'Gestion Commerçant',
        
        debitManagement: 'Gestion Débit',
    
        fraudManagement: 'Gestion Fraude',
    
        holderManagement: 'Gestion Porteurs',
        
        prepaidManagement: 'Gestion Prépayé',
    
        transactionsManagement: 'Gestion Transactions',
    
        gimac: 'GIMAC',
    
        visaBaseII: 'VISA BASE II',
    
};

const opts: FormSelectInputOptionMeta[] = [
    {
        label: 'Archivage',
        value: 'archiving'
    },
    {
        label: 'Gestion Commerçant',
        value: 'merchantManagement'
    },
    {
        label: 'Gestion Débit',
        value: 'debitManagement'
    },
    {
        label: 'Gestion Fraude',
        value: 'fraudManagement'
    },
    {
        label: 'Gestion Porteurs',
        value: 'holderManagement',
        selected: true
    },
    {
        label: 'Gestion Prépayé',
        value: 'prepaidManagement'
    },
    {
        label: 'Gestion Transactions',
        value: 'transactionsManagement'
    },
    {
        label: 'GIMAC',
        value: 'gimac'
    },
    {
        label: 'VISA BASE II',
        value: 'visaBaseII'
    },
]

BatchesMonitoringFilterFormMeta.module = {
  name: 'module',
  type: 'select',
  label: '',
  placeholder: '',
  options: opts,
  validation: yup.string().required('Champ obligatoire !')
};

BatchesMonitoringFilterFormMeta.unknown = {
  name: 'unknown',
  type: 'select',
  label: '',
  placeholder: '',
  validation: yup.string().required('Champ obligatoire !')
};

BatchesMonitoringFilterFormMeta.date = {
  name: 'date',
  type: 'date',
  label: '',
  placeholder: '',
  validation: yup.date()
};

BatchesMonitoringFilterFormMeta.schema = yup.object().shape(getValidationSchema(BatchesMonitoringFilterFormMeta));

export default BatchesMonitoringFilterFormMeta;